// Exemple de script de page, add it to $additional_bottom_scripts = []; on the  page

    //On scroll
    $(document).ready(function() {
        $(window).scroll(function() {
            $('#visible').is(function() {
                var viewing =  $(this).visible();
                if(viewing) {

                    $('.piece').removeClass("inactive");
                }
                else {
                    $('.piece').addClass("inactive");
                }
            });

            $('#visible-door').is(function() {
                var viewing =  $(this).visible();
                if(viewing) {
                    $('.left-door, .right-door').removeClass("inactive");
                }
                else {
                    $('.left-door, .right-door').addClass("inactive");
                }
            });
        })
    });
